// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".MultiPaperNewsStory-cls1___4a35828ab5da2c8a328{/*!*/}.MultiPaperNewsStory-cls2__b3c641dbca791252acea{font-weight:800;padding-bottom:8px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "MultiPaperNewsStory-cls1___4a35828ab5da2c8a328",
	"cls2": "MultiPaperNewsStory-cls2__b3c641dbca791252acea MultiPaperNewsStory-cls1___4a35828ab5da2c8a328"
};
export default ___CSS_LOADER_EXPORT___;
